/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ message: NonNullable<unknown> }} Case_Section_Review_ErrorInputs */

const en_case_section_review_error = /** @type {(inputs: Case_Section_Review_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Could not mark the section as reviewed: ${i?.message}`)
};

const pt_br2_case_section_review_error = /** @type {(inputs: Case_Section_Review_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Não foi possível marcar a seção como revisada: ${i?.message}`)
};

/**
* | output |
* | --- |
* | "Could not mark the section as reviewed: {message}" |
*
* @param {Case_Section_Review_ErrorInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_section_review_error = /** @type {((inputs: Case_Section_Review_ErrorInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Section_Review_ErrorInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_section_review_error(inputs)
	return pt_br2_case_section_review_error(inputs)
});